import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import wrap from '../util/wrap_with_intl_provider';
import Table from '../../../../components/Table';
import ax from '../util/axios';
import { tableParamsBuilder } from '../util/searchUtils';
import DepartmentsRowMenu from './DepartmentsRowMenu';
import SearchBar from '../../../../components/SearchBar';
import { PrimarySearchItems } from './DepartmentSearchForm';
import { organisation_area_settings_department_path } from '../../../../routes';

const DepartmentTable = (props) => {
  const intl = useIntl();
  const [pagination, setPagination] = useState({});
  const [departments, setDepartments] = useState([]);
  const [searchParams, setSearchParams] = useState({});

  const fetchDepartments = async (page = 1) => {
    const response = await ax.get(props.dataUrl + '.json' + tableParamsBuilder({ page, ...searchParams }));
    setPagination(response.data.pagination);
    setDepartments(response.data.departments);
  };

  const departmentColumns = () => {
    const columns = [
      {
        accessor: 'name',
        header: intl.formatMessage({ id: 'departments.search.name-field' }),
      },{
        className: 'actions',
        accessor: 'rowMenu',
      }
    ];

    return columns;
  };

  const mappedDepartments = departments.map((department) => ({
    ...department,
    rowMenu: (
      <DepartmentsRowMenu
        updateUrl={organisation_area_settings_department_path(department.id)}
        deleteUrl={organisation_area_settings_department_path(department.id)}
        details={department}
      />
    ),
  }));

  useEffect(() => {
    fetchDepartments();
  }, [searchParams]);

  return (
    <div>
      <SearchBar
        primaryItems={<PrimarySearchItems />}
        onSearch={setSearchParams}
      />
      {departments.length > 0 && (
        <Table
          header={true}
          items={mappedDepartments}
          columns={departmentColumns()}
          pagination={pagination}
          onPageChange={fetchDepartments}
        />
      )}
    </div>
  );
};

DepartmentTable.propTypes = {
  dataUrl: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool.isRequired,
};

export default wrap(DepartmentTable);
